import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LookupItemStruct } from '../../structs/motor-fiscal/lookup-item.struct';

@Injectable({
    providedIn: 'root',
})
export class MotorFiscalLookupService extends CommonService {
    /**
     * `LookupAdmin`, e não `Lookup`: o controller do Hub aceita somente token de empresa, e o
     * painel autentica com `JwtAdminAuthorization`. O Motor Fiscal expõe um controller separado
     * para o admin, com os catálogos globais (CNAE, regime tributário e situação do contribuinte da empresa).
     */
    private readonly apiUrl: string = environment.urlApiMotorFiscal + 'LookupAdmin';

    constructor(private httpClient: HttpClient) {
        super();
    }

    /**
     * Busca a lista de um endpoint de lookup (formato { list }).
     */
    private getList(rota: string, params?: Record<string, string | number | boolean>): Observable<LookupItemStruct[]> {
        return this.httpClient.get<{ list: LookupItemStruct[] }>(`${this.apiUrl}/${rota}`, {
            ...this.addHeaderToken(),
            params,
        }).pipe(
            map(res => res?.list ?? []),
            catchError(() => of([]))
        );
    }

    /**
     * URL do lookup de CNAE (catálogo 2.3, subclasses), para ligar direto no `[apiUrl]` do
     * `app-select-pesquisavel`. O `codigo` vem mascarado (ex.: "6201-5/01") e a `descricao`
     * já vem composta como "6201-5/01 — Desenvolvimento de programas de computador sob encomenda".
     */
    public get cnaeLookupUrl(): string {
        return `${this.apiUrl}/cnae`;
    }

    /**
     * Busca CNAEs por código ou trecho da descrição. Usado para resolver a descrição de um
     * código já gravado e alimentar o `[preloadedOptions]` do select pesquisável.
     */
    public getCnaes(textoBusca: string): Observable<LookupItemStruct[]> {
        return this.getList('cnae', { textoBusca });
    }

    public getRegimesTributarios(): Observable<LookupItemStruct[]> {
        return this.getList('regime-tributario');
    }

    /** Lucro Real / Lucro Presumido. Só se aplica ao Regime Normal. */
    public getRegimesApuracaoIrpj(): Observable<LookupItemStruct[]> {
        return this.getList('regime-apuracao-irpj');
    }

    public getSituacoesContribuinteEmpresa(): Observable<LookupItemStruct[]> {
        return this.getList('situacao-contribuinte-empresa');
    }
}
